import { render, staticRenderFns } from "./ThanksForEvaluateModal.vue?vue&type=template&id=7bff7a4b&"
import script from "./ThanksForEvaluateModal.vue?vue&type=script&lang=js&"
export * from "./ThanksForEvaluateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports